import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import StrategyInfoTab from './Strategy/StrategyInfoTab';
import StrategyFormTemplate from './StrategyFormTemplate';
import { PhasesProvider } from './phaseTab/PhasesProvider';
import { SepPlansTab } from './SepPlans/SepPlansTab';

export const StrategyTabs = ({
  strategicSupplierDataGridApiRef,
  nonStrategicSupplierDataGridApiRef,
  masterMGCJson,
  setParentMgcData,
  selectedMgc,
  selectedMgcList,
  selectedMgcAfterEdit,
  resetSelectedMgcAfterEdit,
  register,
  commonProps,
  duplicateStrategyList,
  okToPublish,
  masterScopeJson,
  hasUSScope,
  strategyNumber,
  owners,
  approvers,
  ownerObj,
  userInfoMap,
  selectedOverviewViewList,
  setSelectedOverviewViewList,
  readOnly,
  isAdmin,
  isSBM,
  isCommMgr,
  info,
  allMGCSpend,
  supplierScopeOverview,
  collapseExpandedSuppliers,
  setSuppliersDirty,
  setParentSupplierData,
  setSuppliersMessage,
  setParentNonStrategicToPersist,
  setParentNonStrategicSupplierData,
  setCollapseExpandedSuppliers,
  getSpendErrorMsg,
  strategyInformation,
  suppliersMessage,
  setIsStrategyOverviewDirty
}) => {
  const activeTab = useSelector((state) => state.strategy.activeTab);

  return (
    <Grid container>
      <Grid
        size={12}
        role="tabpanel"
        id="strategy-tabpanel-0"
        aria-labelledby="strategy-tab-0"
        hidden={activeTab !== 0}
      >
        {activeTab === 0 && (
          <StrategyInfoTab
            strategicSupplierDataGridApiRef={strategicSupplierDataGridApiRef}
            nonStrategicSupplierDataGridApiRef={
              nonStrategicSupplierDataGridApiRef
            }
            strategyInformation={strategyInformation}
            masterMGCJson={masterMGCJson}
            setParentMgcData={setParentMgcData}
            selectedMgc={selectedMgc}
            selectedMgcList={selectedMgcList}
            selectedMgcAfterEdit={selectedMgcAfterEdit}
            resetSelectedMgcAfterEdit={resetSelectedMgcAfterEdit}
            register={register}
            commonProps={commonProps}
            duplicateStrategyList={duplicateStrategyList}
            okToPublish={okToPublish}
            hasUSScope={hasUSScope}
            masterScopeJson={masterScopeJson}
            strategyNumber={strategyNumber}
            ownerObj={ownerObj}
            owners={owners}
            readOnly={readOnly}
            userInfoMap={userInfoMap}
            selectedOverviewViewList={selectedOverviewViewList}
            setSelectedOverviewViewList={setSelectedOverviewViewList}
            approvers={approvers}
            isAdmin={isAdmin}
            isSBM={isSBM}
            getSpendErrorMsg={getSpendErrorMsg}
            allMGCSpend={allMGCSpend}
            info={info}
            collapseExpandedSuppliers={collapseExpandedSuppliers}
            setSuppliersDirty={setSuppliersDirty}
            setParentSupplierData={setParentSupplierData}
            setSuppliersMessage={setSuppliersMessage}
            setParentNonStrategicToPersist={setParentNonStrategicToPersist}
            setParentNonStrategicSupplierData={
              setParentNonStrategicSupplierData
            }
            setCollapseExpandedSuppliers={setCollapseExpandedSuppliers}
            supplierScopeOverview={supplierScopeOverview}
            isCommMgr={isCommMgr}
            suppliersMessage={suppliersMessage}
            setIsStrategyOverviewDirty={setIsStrategyOverviewDirty}
          />
        )}
      </Grid>

      <Grid
        size={12}
        role="tabpanel"
        id="strategy-tabpanel-1"
        aria-labelledby="strategy-tab-1"
        hidden={activeTab !== 1}
      >
        {activeTab === 1 && (
          <SepPlansTab
            commonProps={commonProps}
            masterScopeJson={masterScopeJson}
          />
        )}
      </Grid>

      <Grid
        size={12}
        role="tabpanel"
        id="strategy-tabpanel-2"
        aria-labelledby="strategy-tab-2"
        hidden={activeTab !== 2}
      >
        {activeTab === 2 && (
          <PhasesProvider
            strategyNumber={strategyNumber}
            activePhase={strategyInformation?.currentPhase}
            userInfoMap={userInfoMap}
          />
        )}
      </Grid>

      <Grid
        size={12}
        role="tabpanel"
        id="strategy-tabpanel-3"
        aria-labelledby="strategy-tab-3"
        hidden={activeTab !== 3}
      >
        {activeTab === 3 && <StrategyFormTemplate commonProps={commonProps} />}
      </Grid>
    </Grid>
  );
};
